import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { ConfiguratorState } from 'models/configurator';
import { Company, RoleProgramResponseList, GetUserCompanyRoles } from 'models/response';
import { UserForRoleRow, ProgramConfigureRole } from 'models/configurator';

const setSelectedCompanyForRoles: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (
  state,
  { payload },
) => {
  state.rolesUserCompany.selectedCompanyIdForRoles = payload;
};

const setCompaniesForRoles: CaseReducer<ConfiguratorState, PayloadAction<Company[]>> = (state, { payload }) => {
  state.rolesUserCompany.companiesForRoles = payload;
};

const setUsersForCompanyRoles: CaseReducer<ConfiguratorState, PayloadAction<GetUserCompanyRoles | null>> = (
  state,
  { payload },
) => {
  state.rolesUserCompany.usersForCompanyRoles = payload;
};

const setSelectedUserForRoles: CaseReducer<ConfiguratorState, PayloadAction<UserForRoleRow[]>> = (
  state,
  { payload },
) => {
  state.rolesUserCompany.selectedUserForRoles = payload;
};

const setUserAvailableRoles: CaseReducer<ConfiguratorState, PayloadAction<RoleProgramResponseList[]>> = (
  state,
  { payload },
) => {
  state.rolesUserCompany.userAvailableRoles = payload;
};

const setTransformedUserRows: CaseReducer<ConfiguratorState, PayloadAction<UserForRoleRow[]>> = (
  state,
  { payload },
) => {
  state.rolesUserCompany.transformedUserRows = payload;
};

const setIsEditingUserRows: CaseReducer<ConfiguratorState, PayloadAction<UserForRoleRow[]>> = (state, { payload }) => {
  state.rolesUserCompany.isEditingUserRows = payload;
};

const setRowIdUserRoles: CaseReducer<ConfiguratorState, PayloadAction<string | null>> = (state, { payload }) => {
  state.rolesUserCompany.editRowId = payload;
};

const setOpenRowId: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.rolesUserCompany.openRowId = payload;
};

const setExternalSelectedUserId: CaseReducer<ConfiguratorState, PayloadAction<number[]>> = (state, { payload }) => {
  state.rolesUserCompany.externalSelectedUserId = payload;
};

const setSelectedProgram: CaseReducer<ConfiguratorState, PayloadAction<ProgramConfigureRole | null>> = (
  state,
  { payload },
) => {
  state.rolesUserCompany.selectedProgram = payload;
};
export default {
  setSelectedCompanyForRoles,
  setCompaniesForRoles,
  setUsersForCompanyRoles,
  setSelectedUserForRoles,
  setUserAvailableRoles,
  setTransformedUserRows,
  setIsEditingUserRows,
  setRowIdUserRoles,
  setOpenRowId,
  setExternalSelectedUserId,
  setSelectedProgram,
};
